var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 209.28 230.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_47);filter:url(#drop-shadow-1);stroke:#fff;stroke-miterlimit:10;stroke-width:1.42px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_47",
    x1: 448.85,
    y1: -193.27,
    x2: 439.95,
    y2: 82.7,
    gradientTransform: "translate(145.48 553.97) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#e0dee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f2f1f3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.4,
    dy: 5.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 11.58
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#010101",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.08 70.02 30.08 149.69 99.08 189.53 168.08 149.69 168.08 70.02 99.08 30.18 30.08 70.02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexWhite);
export default __webpack_public_path__ + "static/media/hex-white.19adcc2741cc68b2cd74a4b7671cbf6a.svg";
export { ForwardRef as ReactComponent };